<template>
  <authenticated-layout>
    <PageHeader title="Coupons" />
    <coupons-data-table />
  </authenticated-layout>
</template>

<script setup lang="ts">

import AuthenticatedLayout from "@/layout/AuthenticatedLayout.vue";
import PageHeader from "@/components/PageHeader.vue";
import CouponsDataTable from "@/components/DataTables/CouponsDataTable.vue";
</script>
